import React, { useState, useEffect } from "react";
import Select from "react-select";
import ApiCaller from "../../../../api/apiCaller";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  CustomInput,
  Label,
  FormGroup,
  Button,
  Input,
} from "reactstrap";
import "./index.css";
import { UserModalInputProps } from "./type";
import t from "utils/Lang";

// The Roster component matches one of two different routes
// depending on the full pathname

const UserFields = [
  { name: "last_name", label: t().site_contact_modal__first_name },
  { name: "first_name", label: t().site_contact_modal__last_name },
  { name: "username", label: "Username" },
  { name: "email", label: "Email" },
];

const UserModal = ({
  isShow,
  isEdit,
  onModalToggle,
  selectedUser,
  onUserSaved,
}: UserModalInputProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(isShow);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [newUserPassword, setNewUserPassword] = useState<string>("");
  const [roles, setRoles] = useState<Array<any>>([]);
  const [zones, setZones] = useState<Array<any>>([]);
  const [user, setUser] = useState<any>(
    selectedUser || {
      is_brand_admin_user: false,
      is_active: true,
    }
  );
  const [selectedRoles, setSelectedRoles] = useState<Array<any>>(
    selectedUser && selectedUser.roles
      ? selectedUser.roles.map((role: any) => {
          return { value: role.id, label: role.name };
        })
      : []
  );
  const [selectedZones, setSelectedZones] = useState<Array<any>>(
    selectedUser && selectedUser.zones
      ? selectedUser.zones.map((zone: any) => {
          return { value: zone.id, label: zone.name };
        })
      : []
  );
  const toogleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (onModalToggle) {
      onModalToggle(isModalOpen);
    }
  };
  const updateAttr = (attrName: string, value: any) => {
    const updatedUser = { ...user };
    updatedUser[attrName] = value;
    setUser(updatedUser);
  };
  const onSelectRoles = (inputRoles: any) => {
    setSelectedRoles(inputRoles);
  };
  const updateRolesToUsers = () => {
    const updatedUser = { ...user };
    updatedUser.roles = selectedRoles
      ? selectedRoles.map((role: any) => {
          return { id: role.value, name: role.label };
        })
      : [];
    setUser(updatedUser);
  };
  const onSelectZones = (inputZones: any) => {
    setSelectedZones(inputZones);
  };
  const updateZonesToUsers = () => {
    const updatedUser = { ...user };
    updatedUser.zones = selectedZones
      ? selectedZones.map((zone: any) => {
          return { id: zone.value, name: zone.label };
        })
      : [];
    setUser(updatedUser);
  };
  const saveUser = async () => {
    setIsSubmitting(true);
    let uri = `user`;
    if (user.id) {
      // Update
      uri = `${uri}/${user.id}`;
    } else {
      // Create
      uri = `${uri}/create`;
    }
    const res = await ApiCaller.post(uri, user);
    if (res.status === "ok") {
      const newUser = res.result;
      setUser(newUser);
      if (newUser.password) {
        alert(`Password for this user: ${newUser.password}`);
        setNewUserPassword(newUser.password);
      }
      toogleModal();
      if (onUserSaved) {
        onUserSaved(res.result);
      }
    } else {
      alert(res.msg || res.message);
    }
    setIsSubmitting(false);
  };
  const getRoles = async () => {
    const res = await ApiCaller.get("brand/roles");
    if (res.result) {
      setRoles(
        res.result.map((role: any) => {
          return { value: role.id, label: role.name };
        })
      );
    }
  };
  const getZones = async () => {
    const res = await ApiCaller.get("zone/");
    if (res?.result) {
      const normalizedZones: any = [];
      res.result.forEach((zone: any) => {
        normalizedZones.push({ label: zone.name, value: zone.id, zone });
      });
      setZones(normalizedZones);
    }
  };
  const onResetPasswordClick = async () => {
    const r = window.confirm("Bạn có chắc sẽ reset mật khẩu của user này?");
    if (r) {
      const res = await ApiCaller.post(`user/${user.id}/reset_password`);
      if (res.status === "ok") {
        setNewUserPassword(res.result.new_password);
      }
    }
  };
  useEffect(() => {
    getRoles();
    getZones();
  }, []);
  useEffect(() => {
    updateRolesToUsers();
  }, [selectedRoles]);
  useEffect(() => {
    updateZonesToUsers();
  }, [selectedZones]);
  return (
    <Modal isOpen={isShow} size="lg" centered toggle={toogleModal}>
      <ModalHeader toggle={toogleModal}>
        {!user.id ? "Tạo mới" : "Chỉnh sửa"}
      </ModalHeader>
      <ModalBody>
        <div>
          {UserFields.map((userField) => (
            <FormGroup key={`${userField.name}`} row>
              <Label sm={2}>{userField.label}</Label>
              <Col sm={10}>
                <Input
                  type="text"
                  value={user[userField.name]}
                  placeholder={userField.label}
                  onChange={(e) => updateAttr(userField.name, e.target.value)}
                />
              </Col>
            </FormGroup>
          ))}
          <FormGroup row>
            <Label sm={2}>{t().setting_user__user_roles}</Label>
            <Col sm={10}>
              <Select
                isMulti
                value={selectedRoles}
                options={roles}
                onChange={(inputRoles) => onSelectRoles(inputRoles)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={2}>{t().setting_user__zone}</Label>
            <Col sm={10}>
              <Select
                isMulti
                value={selectedZones}
                options={zones}
                onChange={(inputZones) => onSelectZones(inputZones)}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <CustomInput
              id="is_active"
              type="switch"
              label={t().setting_user__active}
              onChange={(e) => updateAttr("is_active", !user.is_active)}
              checked={user.is_active}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              id="is_brand_admin_user"
              type="switch"
              label={t().setting_user__brand_management}
              onChange={(e) =>
                updateAttr("is_brand_admin_user", !user.is_brand_admin_user)
              }
              checked={user.is_brand_admin_user}
            />
          </FormGroup>
          <FormGroup>
            <Button size="sm" color="warning" onClick={onResetPasswordClick}>
              {t().setting_user__reset_password}
            </Button>
          </FormGroup>
          {newUserPassword && (
            <p>
              {t().setting_user__password_is} <b>{newUserPassword}</b>
            </p>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toogleModal}>
          {newUserPassword ? t().action__close : t().action__cancel}
        </Button>
        <Button
          color={isSubmitting ? "secondary" : "success"}
          onClick={saveUser}
          disabled={isSubmitting}
        >
          {isSubmitting ? t().action_saving : t().action__save}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserModal;
